import track from '../../Gated/src/tracking/eventTracker';

const savedItemsEventName = 'shopx.saved_items';

export const trackSavedIconClickEvent = canonical => {
  return track({
    event_name: savedItemsEventName,
    canonical_name: canonical,
    action_type: 'click',
    action_name: 'saved_icon_click',
  });
};

export const trackSavedItemStatusChange = ({
  productEventsContext,
  skuId,
  externalProductId,
  savedStatus,
  canonicalName,
}) => {
  const actionName = savedStatus
    ? 'save_item_for_later'
    : 'unsave_item_for_later';

  return track({
    event_name: savedItemsEventName,
    canonical_name: canonicalName,
    action_type: 'click',
    action_name: actionName,
    sku_id: skuId,
    external_product_id: externalProductId,
    source: productEventsContext.source,
    collection: productEventsContext.collection,
  });
};

export const trackSaveForLaterFromBag = ({
  skuId,
  outOfStock,
  externalProductId,
}) => {
  return track({
    event_name: savedItemsEventName,
    canonical_name: 'shopping_bag',
    action_type: 'click',
    action_name: 'save_item_for_later',
    sku_id: skuId,
    external_product_id: externalProductId,
    out_of_stock: outOfStock,
  });
};

export const trackSavedItemsToastClick = ({ canonicalName }) => {
  track({
    event_name: savedItemsEventName,
    canonical_name: canonicalName,
    action_type: 'click',
    action_name: 'clicked_toast_saved',
  });
};

export const trackSavedItemsViewAllClick = () => {
  track({
    event_name: savedItemsEventName,
    canonical_name: 'shopping_bag',
    action_type: 'click',
    action_name: 'clicked_into_saved_items',
  });
};

export const savedItemsCarouselSeenInViewport = ({ savedItemsSkuIds }) => {
  track({
    event_name: savedItemsEventName,
    canonical_name: 'shopping_bag',
    action_type: 'view',
    action_name: 'view_carousel_saved',
    saved_item_sku_ids: savedItemsSkuIds,
  });
};

export const savedItemsCarouselScroll = ({
  savedItemIsVisible,
  savedItemSkuId,
  savedItemsSkuIds,
}) => {
  track({
    event_name: savedItemsEventName,
    canonical_name: 'shopping_bag',
    action_type: 'scroll',
    action_name: 'scroll_carousel_saved',
    saved_item_is_visible: savedItemIsVisible,
    saved_item_sku_id: savedItemSkuId,
    saved_item_sku_ids: savedItemsSkuIds,
  });
};

export const trackSavedItemsPDPVisit = ({ skuId }) => {
  track({
    event_name: savedItemsEventName,
    canonical_name: 'shopping_bag',
    action_type: 'click',
    action_name: 'clicked_into_pdp',
    sku_id: skuId,
  });
};

export const trackSavedItemsAddToBag = ({
  skuId,
  canonicalName,
  savedCarousel,
  productEventsContext,
  externalProductId,
}) => {
  track({
    event_name: savedItemsEventName,
    canonical_name: canonicalName,
    action_type: 'click',
    action_name: 'add_to_bag',
    sku_id: skuId,
    external_product_id: externalProductId,
    from_saved_carousel: savedCarousel,
    source: productEventsContext.source,
    collection: productEventsContext.collection,
    sub_source: productEventsContext.subSource,
  });
};
const formattedSkus = savedItems => {
  return savedItems.map(item => ({
    out_of_stock: !item.isAvailable,
    sku_id: item.node.selectedSku.id,
    source: item.productEventsContext.source,
    collection: item.productEventsContext.collection,
  }));
};

export const trackSavedItemsIndexView = savedItems => {
  return track({
    event_name: savedItemsEventName,
    canonical_name: 'saved_items',
    action_type: 'view',
    action_name: 'page_view',
    skus: formattedSkus(savedItems),
  });
};

export const trackSavedItemsPDPClick = ({
  productEventsContext,
  skuId,
  externalProductId,
}) => {
  track({
    event_name: savedItemsEventName,
    canonical_name: 'saved_items',
    action_type: 'click',
    action_name: 'clicked_into_pdp',
    sku_id: skuId,
    external_product_id: externalProductId,
    source: productEventsContext.source,
    collection: productEventsContext.collection,
    sub_source: productEventsContext.subSource,
  });
};

export const trackSavedItemsBuyNowClick = ({
  productEventsContext,
  skuId,
  externalProductId,
}) => {
  track({
    event_name: savedItemsEventName,
    canonical_name: 'saved_items',
    action_type: 'click',
    action_name: 'buy_now',
    sku_id: skuId,
    external_product_id: externalProductId,
    source: productEventsContext.source,
    collection: productEventsContext.collection,
    sub_source: productEventsContext.subSource,
  });
};

export const trackSavedItemsInStockClick = ({ inStockOnly }) => {
  track({
    event_name: savedItemsEventName,
    canonical_name: 'saved_items',
    action_type: 'click',
    action_name: 'in_stock_toggle',
    in_stock_only: inStockOnly,
  });
};
